import { Component } from '@angular/core';
import { Project } from 'src/app/models/project';
import { ServiceManager } from 'src/app/services/configurators-2d/service-manager';
import { ProjectService } from 'src/app/services/project.service';
import { MODAL, ModalService } from '../../services/modal.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CONFIG_CONTEXT } from 'src/app/enum/config-context.enum';
import { KitchenService } from 'src/app/services/configurators-2d/applications/kitchen.service';
import { logError } from 'src/app/services/helpers/sentry.helper';

@Component({
  selector: 'ng-casto-project-duplicate',
  templateUrl: './project-duplicate.component.html',
})
export class ProjectDuplicateComponent {
  currentError: number;
  isLoading: boolean = false;
  onClose: (p: any) => {};
  project: Project;
  projectName: string;

  constructor(
    public modal: ModalService,
    private readonly projectService: ProjectService,
    private readonly serviceManager: ServiceManager,
    private readonly modalService: ModalService
  ) {
    this.project = this.modal.currentDatas.project;
    this.projectName = this.project.projectName;
    this.onClose = this.modal.currentDatas.onClose;
    this.currentError = 0;
  }

  checkForm() {
    this.currentError = 0;
    if (this.projectName.trim() == '') {
      this.currentError = 1;
    }

    if (this.projectName == this.project.projectName) {
      this.currentError = 2;
    }
  }

  async submit() {
    this.checkForm();
    if (this.currentError == 0) {
      this.isLoading = true;

      /**
       Si c'est un projet Kitchen :
       1- Faut faire this.projectService.duplicate pour dupliquer le projet byMe
       2- Faut faire le duplicateProjectById pour dupliquer kitchen config et update la config avec le nouvel ProjectUUID
       */
      //faire la meme mecanique que dans delete
      let updateByMePromise: Promise<any> = Promise.resolve();
      let updatePromise: Promise<any> = Promise.resolve();
      let service;
      if (
        this.project.distributionID == environment.byMe.kitchen.distribID //si c'est un projet kitchen ==> à chnager quand il y aura d'autre config 3d
      ) {
        service = this.serviceManager.getService(CONFIG_CONTEXT.KITCHEN) as KitchenService;
        try {
          let kitchenConfig = await service.getLiteKitchenConfiguration(this.project.projectUUID);
          updatePromise = service.duplicateKitchen({
            hbmConfigurationId: this.project.projectUUID,
            tunnelConfigurationId: kitchenConfig?.id,
            newTunnelTitle: this.projectName.trim(),
          });
        } catch { }

        updateByMePromise = this.projectService.duplicate(
          this.project.projectID,
          this.project.projectUUID,
          this.projectName.trim()
        );
      } else if (
        this.project.distributionID == environment.byMe.storage.distribID //si c'est un projet storage ==> à chnager quand il y aura d'autre config 3d
      ) {
        service = this.serviceManager.getService(CONFIG_CONTEXT.STORAGE);
        try {
          let storageConfig = await service.getLiteStorageConfiguration(this.project.projectUUID);
          updatePromise = service.duplicateStorage({
            hbmConfigurationId: this.project.projectUUID,
            tunnelConfigurationId: storageConfig?.id,
            newTunnelTitle: this.projectName.trim(),
          });
        } catch { }
        updateByMePromise = this.projectService.duplicate(
          this.project.projectID,
          this.project.projectUUID,
          this.projectName.trim()
        );
      } else {
        service = this.serviceManager.getService(this.project.distributionID);
        if (service) {
          // si ya un service dès le départ (projet 2d)
          updatePromise = service.duplicateProjectById(this.project.projectID, this.projectName.trim());
        } else {
          //sinon (autre config 3d)
          updateByMePromise = this.projectService.duplicate(
            this.project.projectID,
            this.project.projectUUID,
            this.projectName.trim()
          );
        }
      }

      updateByMePromise
        .then(clonedProjectUUID => {
          if (clonedProjectUUID) {
            //Si il y a un clonedProjectUUID, c'est que updateByMePromise a été affecté
            if (
              this.project.distributionID == environment.byMe.kitchen.distribID ||
              this.project.distributionID == environment.byMe.storage.distribID
            ) {
              updatePromise.then(configuration => {
                let p = new Project();
                p.projectUUID = clonedProjectUUID;
                this.isLoading = false;
                this.close(p);
              });
            } else {
              let p = new Project();
              p.projectUUID = clonedProjectUUID;
              this.isLoading = false;
              this.close(p);
            }
          } else {
            updatePromise.then(configuration => {
              let config: any = {};
              config.distributionID = this.project.distributionID;
              config.projectUUID = configuration.id;
              this.isLoading = false;
              this.close(config);
            });
          }
        })
        .catch((err: HttpErrorResponse) => {
          logError(err);
          this.isLoading = false;
          this.modalService.display(MODAL.GENERIC_ERROR, {
            errorMessage: err.error.message,
          });
        });
    }
  }

  cancel() {
    this.close(null);
  }

  private close(clonedProject: Project | any | null): void {
    this.modal.close(clonedProject);
    if (this.onClose) {
      this.onClose(clonedProject);
    }
  }
}
